<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="活动名称" name="activity_name"></c-form-item>
					<c-form-item type="checkbox" label="活动状态" name="start_state" :options="activityState"></c-form-item>
					<c-form-item type="checkbox" label="启/禁用状态" name="state" :options="stateOptions"></c-form-item>

				</c-form>
			</m-search>
			
			<m-operate>
				<c-button power="b_activity_gifts_edit" color="sys" @click="navigateTo('/reward_gift_add')">新建活动</c-button>
			</m-operate>
			
			<c-table ref="table">

				<c-table-column
					label="活动状态"
					name="start_state"
                  width="80"
                >
                      <template v-slot="{data}">
                        <span v-if="data.start_state == 0" style="color:#999">{{activityStateText[data.start_state]}}</span>
                        <span v-if="data.start_state == 1" style="color:dodgerblue">{{activityStateText[data.start_state]}}</span>
                        <span v-if="data.start_state == 2" style="color:red">{{activityStateText[data.start_state]}}</span>
                      </template>
				</c-table-column>

                <c-table-column
                        label="启/禁用状态"
                        name="state"
                        width="90"
                >
                    <template v-slot="row">
                        <c-switch v-if="auth('b_activity_gifts_edit') && row.data.start_state == 0||row.data.start_state == 1" :value="row.data.state == 2" text="启用,禁用"
                                  @change="changeActivityState(row, arguments[0], arguments[1])"></c-switch>
                        <strong v-if="row.data.start_state == 2 && row.data.state == 1" style="color: darkgray">禁用</strong>
                        <strong v-if="row.data.start_state == 2 && row.data.state == 2" style="color: green">启用</strong>
                    </template>
                </c-table-column>

				<c-table-column
					label="活动名称"
					name="activity_name"
					width="200"
				></c-table-column>

				<c-table-column
					label="赠品是否叠加"
					name="gifts_kinds"
					width="100"
				>
                    <template v-slot="{data}">
                        <span v-if="data.gifts_kinds == 1" style="color:dodgerblue">叠加</span>
                        <span v-if="data.gifts_kinds == 2" style="color:darkgray">不叠加</span>
                    </template>
                </c-table-column>

				<c-table-column
					label="活动标签"
					name="tags"
					width="120"
				>
                    <template v-slot="{data}">
                        <span v-if="data.tags">{{data.tags}}</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>

				<c-table-column
					label="活动时间"
					width="300"
				>
					<template v-slot="{data}">{{data.begin_date}} 至 {{data.end_date}}</template>
				</c-table-column>
				
				<c-table-column
					label="创建时间"
					width="140"
					name="create_date"
				>
				</c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="200"
				>
					<template v-slot="row">
						<c-table-button power="m_limit_time_discount" @click="navigateTo(`/reward_gift_detail/${row.data.id}`)">查看</c-table-button>
            <c-table-button power="b_activity_gifts_edit" v-if="row.data.state == 1 || row.data.start_state == 2" @click="navigateTo(`/reward_gift_edit/${row.data.id}`)">编辑</c-table-button>
            <c-table-button power="b_activity_gifts_edit" v-if="row.data.state == 1 || row.data.start_state == 2" @click="deleteActivity(row)">删除</c-table-button>
						<c-table-button power="b_activity_gifts_edit" v-if="row.data.state == 1 || row.data.start_state == 2" @click="copyActivity(row)">复制</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
		name: 'm_activity_gifts',
		
		data() {
			return {
				activityState: [
                    {name: '未开始',value: 0},
                    {name: '进行中',value: 1},
                    {name: '已结束',value: 2},
                    {name: '暂停中',value: 3}
				],
                stateOptions: [
                    {name: '禁用',value: 1},
                    {name: '启用',value: 2}
                ]
			}
		},
		
		computed: {
            ...mapState(['systemConfig', 'userInfo']),
            ...mapGetters({
                auth: 'power'
            }),
            activityStateText() {
                var state = {};
                this.activityState.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            }
		},
		
		mounted() {
			this.$refs.search.search();
			this.$bus.$on('rewardGiftList.update', () => {
				this.$refs.search.search();
			});
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/activityGifts/list',
					data
				});
			},
            /**
               * 启禁用
               * @param item
               * @param state true = 启用  false=禁用
            */
			changeActivityState(item,state, stop) {
                stop();
				this.$confirm({
					text: '确定要'+(state?"启用":"禁用")+'活动【'+item.data.activity_name+'】吗？',
					resolve: () => {
						this.request({
                            url: '/activitySale/updateActivityState',
							data: {
								id: item.data.id,
                                state:state?2:1
							},
							loading: true,
							success: () => {
								this.$message({
									text: (state?"启用":"禁用")+'成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			},
			
			deleteActivity(item) {
				this.$confirm({
                    text: '确定要删除此活动【'+item.data.activity_name+'】吗？',
					resolve: () => {
						this.request({
                            url: '/activitySale/remove',
							data: {
								id: item.data.id
							},
							loading: true,
							success: () => {
								this.$message({
									text: '删除成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			},
			copyActivity(item) {
                this.$confirm({
                    text: '确定要复制此满赠活动【'+item.data.activity_name+'】吗？',
                    resolve: () => {
                        this.request({
                            url: '/activityGifts/copy',
                            data: {
                                id: item.data.id
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: '复制成功'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
			}
		}
	}
</script>